import styled from 'styled-components';

export const StyledTopTips = styled.div`
  ${({ theme: { space } }) => `
    padding: ${space[6]};
  `}
`;
